import { Component, Prop, h, Fragment } from '@stencil/core';
import { sprintf, __ } from '@wordpress/i18n';
import { openWormhole } from 'stencil-wormhole';
import { Checkout } from '../../../../types';
import { formatTaxLineDetail, getTaxLines, TaxLine } from '../../../../functions/tax';

@Component({
  tag: 'sc-line-item-tax',
  styleUrl: 'sc-line-item-tax.scss',
  shadow: true,
})
export class ScLineItemTax {
  @Prop() order: Checkout;
  @Prop() loading: boolean;

  renderLabel(line: TaxLine, showDetail: boolean) {
    let label = sprintf(__('Estimated %s', 'surecart'), line.label || '');

    if (this?.order?.tax_status === 'calculated') {
      label = line.label || '';
    }

    return (
      <Fragment>
        {`${__('Tax', 'surecart')} ${label}`}
        {showDetail && ` ${formatTaxLineDetail(line)}`}
      </Fragment>
    );
  }

  render() {
    const lines = getTaxLines(this.order);

    // hide if tax is 0
    if (!lines.length) {
      return null;
    }

    // tax_behavior is set on the account's tax protocol, so a checkout is
    // either fully inclusive or fully exclusive — never mixed.
    const included = !!this.order?.tax_inclusive_amount;

    // Rate/base detail only earns its space when there is more than one row to tell apart.
    const showDetail = lines.length > 1;

    return (
      <Fragment>
        {lines.map(line => (
          <sc-line-item key={`${line.label}-${line.rate}`}>
            <span slot="description">{this.renderLabel(line, showDetail)}</span>

            {included ? (
              <span slot="price-description">
                {'('}
                {line.display_amount} {__('included', 'surecart')}
                {')'}
              </span>
            ) : (
              <span slot="price">{line.display_amount}</span>
            )}
          </sc-line-item>
        ))}
      </Fragment>
    );
  }
}

openWormhole(ScLineItemTax, ['order', 'loading'], false);
